// extracted by mini-css-extract-plugin
export default {"title":"Title_title__RGeJI","title2":"Title_title2__ufEyC"};